import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_APPLY_PAGE_PATH } from './constants/path'

export const priceCompareApplyRoute: RouteItem = {
  title: '比价采购报名',
  hideInMenu: true,
  path: PRICE_COMPARE_APPLY_PAGE_PATH,
  Component: () => import('./index')
}
